import { queryOptions, useQuery } from "@tanstack/react-query";
import { parseResponse } from "lib/fetch";
import { getMobileLinksRequest } from "lib/api/reference/mobileLink";
import type { MobileLinkInterface } from "types/reference";

export const mobileLinkReferenceKeys = {
    all: ["reference", "mobile-link"] as const,
    list: (languageCode: string) => [...mobileLinkReferenceKeys.all, "list", languageCode] as const,
};

export const fetchMobileLinks = (languageCode: string) =>
    parseResponse<Array<MobileLinkInterface>>(getMobileLinksRequest(languageCode));

export const mobileLinkReferenceQueryOptions = (languageCode: string) =>
    queryOptions<Array<MobileLinkInterface>>({
        queryKey: mobileLinkReferenceKeys.list(languageCode || "__missing__"),
        queryFn: () => fetchMobileLinks(languageCode),
        enabled: Boolean(languageCode),
    });

export const useMobileLinks = (languageCode: string) => useQuery(mobileLinkReferenceQueryOptions(languageCode));
